<template>
  <div id="app">
    <vue-headful :title="title" />
    <Header />
    <b-container id="masterContainer">
      <b-row>
        <b-col>
          <Expenses />
        </b-col>
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Expenses from './components/Expenses.vue'
import Footer from './components/Footer.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'app',
  data () {
    return {
      siteBrand: process.env.VUE_APP_BRAND, /* ABC | ABCBS | EBCBS */
      title: 'Act Wise QME'
    }
  },
  mounted () {
    this.setTitle()
  },
  methods: {
    setTitle () {
      switch (this.siteBrand) {
        case 'EBCBS':
          this.title = 'Anthem Blue Cross Act Wise QME'
          break
        case 'ABC':
          this.title = 'Anthem Blue Cross Act Wise QME'
          break
        case 'ABCBS':
          this.title = 'Anthem Blue Cross Blue Shield Act Wise QME'
      }
    }
  },
  components: {
    Header,
    Expenses,
    Footer
  }
}
</script>

<style lang="scss">
$color-Q: #659c41 ;
$color-PQ: #a3a3a3;
$color-NQ: #d02037;
$color-A: #0373bb;
$color-text: #333333;
$filterButton-height: 120px;
$filterButton-colorBar-height: 30px;
$filterButton-colorBar-padding: 90px;
$filterButton-transitionTime: 0.4s;

// Set Breakpoints to match Bootstrap
$breakpoints: (
  "xs": (
    max-width: 575px
  ),
  "sm": (
    min-width: 576px
  ),
  "md": (
    min-width: 720px
  ),
  "lg": (
    min-width: 992px
  ),
  "xl": (
    min-width: 1200px
  )
);
@mixin respond-to($breakpoint) {
  $raw-query: map-get($breakpoints, $breakpoint);

  @if $raw-query {
    $query: if(
      type-of($raw-query) == "string",
      unquote($raw-query),
      inspect($raw-query)
    );

    @media #{$query} {
      @content;
    }
  } @else {
    @error 'No value found for `#{$breakpoint}`. '
         + 'Please make sure it is defined in `$breakpoints` map.';
  }
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-text;
  background-color: #f1f1f1;
}
img.HeaderLogo { 
  width: 250px;
}
img.HeaderLogo.AnthemBC {
   width: 220px;
}

.headlineUnderline.animate:after {
  width: 108px;
}
#top-bar {
  background-color: #ffffff;
  padding: 20px;
}
.home-banner {
  .banner-img {

    @include respond-to("md") {
      background: url("./assets/hero.jpg") no-repeat center center;
      background-size: cover;
      min-height: 520px;
    }
  }
}

#contentHeader {
  background: url("./assets/bluePattern.png") no-repeat center center;
  background-size: cover;
  min-height: 250px;
  color:#ffffff;
  padding-top:30px;
  border-radius: 5px;
  h2{
    color:#ffffff;
  }
   @include respond-to("xs") {
     width:99%;
     margin: 0px auto 0 auto;
   }
    @include respond-to("sm") {
     width:99%;
     margin: 0px auto 0 auto;
   }
    @include respond-to("md") {
     margin: -200px auto 0 auto;
     max-width: 800px;
     width: 100%
   }
    @include respond-to("lg") {
     margin: -200px auto 0 auto;
     max-width: 1040px;
     width: 100%
   }
    @include respond-to("xl") {
     margin: -200px auto 0 auto;
     max-width: 1240px;
     width: 100%
   }
}

#masterContainer {
  padding-top: 40px;
  padding-bottom: 60px;
  background-color: #ffffff;
   @include respond-to("md") {
     border-radius: 5px;
     margin-top:-80px;
   }
   @include respond-to("sm") {
     margin-top:-80px;
   }
}
.anthem-icon {
  height: 35px;
  &.fa-question-circle {
    color: $color-PQ;
  }
  &.fa-times-circle {
    color: $color-NQ;
  }
  &.fa-check-circle {
    color: $color-Q;
  }
  svg {
    width: 30px;
  }
}

.bodyContent {
  text-align:center;
  p{
    padding-bottom:30px;
  }
  p.normal {
    margin-top: 0;
    margin-bottom: 1rem;
    padding-bottom: 0px;
  }
  div.sample-icon,span.sample-icon{
    display: inline-block;
    width: 18px;
    margin: 0;
    .qIcon {
      color: $color-Q;
    }
    .pqIcon {
      color: $color-PQ;
    }
    .nqIcon {
      color: $color-NQ;
    }
  }
}

#filterButtons {
  text-align: center;
  a {
    padding: 0;
    margin: 0;
    background: #f1f1f1;
    border-color: #ffffff;
    height: $filterButton-height;
    position: relative;
    z-index: 0;
    &:hover {
      background-color: #ebebeb;
    }
    &#filter-Q {
      &.active {
        .pointer {
          border-top-color: $color-Q;
        }
        .colorBar {
          height: $filterButton-height;
          top: 0;
        }
      }
      .colorBar {
        background-color: $color-Q;
      }
    }
    &#filter-PQ {
      &.active {
        .pointer {
          border-top-color: $color-PQ;
        }
        .colorBar {
          height: $filterButton-height;
          top: 0;
        }
      }
      .colorBar {
        background-color: $color-PQ;
      }
    }
    &#filter-NQ {
      &.active {
        .pointer {
          border-top-color: $color-NQ;
        }
        .colorBar {
          height: $filterButton-height;
          top: 0;
        }
      }
      .colorBar {
        background-color: $color-NQ;
      }
    }
    &#filter-A {
      &.active {
        .pointer {
          border-top-color: $color-A;
        }
        .colorBar {
          height: $filterButton-height;
          top: 0;
        }
      }
      .colorBar {
        background-color: $color-A;
      }
      .heading {
        padding: 40px 0 20px 0;
      }
    }
    &.active {
      color: #ffffff;
      .anthem-icon {
        color: #ffffff;
      }
      .heading {
        top: 10px;
      }
    }
    .pointer {
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-top: 20px solid transparent;
      position: absolute;
      top: $filterButton-height;
      margin-left: -20px;
      left: 50%;
    }
    .colorBar {
      transition: top $filterButton-transitionTime ease-in,
        height $filterButton-transitionTime ease-in;
      position: absolute;
      width: 100%;
      height: $filterButton-colorBar-height;
      top: $filterButton-colorBar-padding;
      z-index: 1;
    }
    .heading {
      transition: top $filterButton-transitionTime ease-in,
        color $filterButton-transitionTime ease-in;
      position: relative;
      top: -10px;
      z-index: 2;
      .text {
        display: none;
        @include respond-to("sm") {
          display: inherit;
          line-height: 1.2;
        }
        @include respond-to("lg") {
          line-height: inherit;
        }
      }
    }
    .anthem-icon {
      transition: color $filterButton-transitionTime ease-in;
    }
  }
}
.expenseTypeHeading{
  font-size:1.5em;
  font-weight: bold;
  text-align:center;
  padding:10px 0;
  display:inherit;
  @include respond-to("sm") {
    display:none;
  }
  .a{
    color:$color-A;
  }
  .q{
    color:$color-Q;
  }
  .pq{
    color:#666666;
  }
  .nq{
    color:$color-NQ;
  }
}
#searchExpenseList {
  margin: 10px 0 40px 0;
  .searchIcon {
    color: $color-A;
    max-height: 36px;
    margin: 2px 0 0 0;
  }
}
#expenseList {
  list-style: none;
  padding: 30px 0 0 5px;
  .list-icon {
    float: left;
    width: 24px;
    margin: 0 8px 0 0;
    .qIcon {
      color: $color-Q;
    }
    .pqIcon {
      color: $color-PQ;
    }
    .nqIcon {
      color: $color-NQ;
    }
  }
  .list-text {
    float: left;
    width: 87%;
    padding-bottom: 25px;
  }
  @include respond-to("md") {
    // column-count: 2;
  }
  @include respond-to("xl") {
    // column-count: 3;
  }

  li {
    color: $color-text;

    a {
      &.RX,
      &.L {
        color: #0b7abf;
        .down-arrow {
          width: 10px;
          margin-top: -10px;
          color: #666;
        }
      }
      &.E,
      &.NC {
        color: $color-text;
        .down-arrow {
          display: none;
        }
      }
      &.E:hover,
      &.NC:hover {
        text-decoration: none;
        cursor: default;
      }
    }

    .card {
      border: $color-PQ solid 2px;
      border-left: none;
      border-right: none;
      .card-body {
        background-color: #f1f1f1;
        padding: 1rem;
      }
    }
    i {
      padding-right: 5px;
    }
  }
}

h2 {
  font-weight: 300;
  color: #56545e;
  font-size: 40px;
  &.headlineUnderline:after {
    background-color: #41c0b8;
    content: "";
    display: block;
    height: 4px;
    margin: 30px auto 30px;
    position: relative;
    width: 108px;
    transition: 1500ms cubic-bezier(0.87, -0.41, 0.19, 1.44);
  }
}

#revision-statement {
  margin-top: 10px;
  font-style: italic;
}

#footer {
  margin-top: 60px;
  font-size: 20px;
  .list-inline {
    li {
      margin-right: 2rem;
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
